import { createSelector } from '@ngrx/store';
import { selectEquipment } from './equipment.reducer';

export const selectFilteredEquip = createSelector(
  selectEquipment,
  equip => equip.typeFilter
);
